import * as React from 'react';
import { markUpUtils } from '@origin-digital/utils-toolbox';
import './terms-and-conditions.scss';

function getTermsByRegion(terms, region, showTargetTestTncs) {
  region = typeof region === 'string' ? region.toLowerCase() : '';
  let tncs = terms[region || terms.defaultTerms] || '';
  const abTncs = terms['targetTest'] || '';
  return showTargetTestTncs ? tncs + abTncs : tncs;
}

interface ITermsAndConditions {
  terms: {
    defaultTerms: string;
    act: string;
    nsw: string;
    qld: string;
    nt: string;
    sa: string;
    tas: string;
    vic: string;
    wa: string;
  };
  region: string;
  showTargetTestTncs: boolean;
}

export default function TermsAndConditions(props: ITermsAndConditions) {
  const { terms = {}, region = '', showTargetTestTncs } = props;
  const markupObject = markUpUtils.createDangerousMarkupObject(
    getTermsByRegion(terms, region, showTargetTestTncs),
  );
  return <div className="terms-and-conditions" dangerouslySetInnerHTML={markupObject} />;
}
